import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { ChatCircleText, PaperPlaneTilt, WhatsappLogo } from "@phosphor-icons/react";

export default function Chat() {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const boxRef = useRef(null);

  const load = async () => { const { data } = await api.get("/messages"); setMessages(data); setTimeout(() => boxRef.current?.scrollTo(0, boxRef.current.scrollHeight), 100); };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const h = (e) => { if (e.detail?.entity === "message") load(); };
    window.addEventListener("live-event", h);
    return () => window.removeEventListener("live-event", h);
  }, []);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try { await api.post("/messages", { text, kind: "suggestion" }); setText(""); load(); }
    catch { toast.error("Erro ao enviar"); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
            <ChatCircleText size={32} weight="duotone" className="text-blue-600" /> Chat & Sugestões
          </h1>
          <p className="text-muted-foreground text-sm mt-1">Perguntas, sugestões e melhorias entre empresa e motorista</p>
        </div>
        <a href="https://wa.me/?text=Olá!%20Sugestão%20para%20o%20Acerto%20Rápido%20JVO:" target="_blank" rel="noreferrer">
          <Button variant="outline" data-testid="btn-whatsapp-support" className="border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800 gap-2"><WhatsappLogo size={18} /> Falar no WhatsApp</Button>
        </a>
      </div>

      <Card>
        <CardHeader><CardTitle className="text-lg">Conversa da empresa</CardTitle></CardHeader>
        <CardContent>
          <ScrollArea ref={boxRef} className="h-[420px] pr-4 border rounded-md p-3 bg-slate-50">
            {messages.length === 0 && <p className="text-muted-foreground text-sm text-center py-8">Nenhuma mensagem ainda. Envie a primeira!</p>}
            <div className="space-y-3">
              {messages.map((m) => {
                const mine = m.user_id === user.id;
                return (
                  <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                    <div className={`max-w-[80%] rounded-lg px-3 py-2 text-sm ${mine ? "bg-blue-600 text-white" : "bg-white border border-border"}`}>
                      <div className="text-[10px] uppercase tracking-wider opacity-80 mb-0.5">{m.user_name} • {m.role === "company" ? "Empresa" : "Motorista"}</div>
                      <div>{m.text}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </ScrollArea>
          <form onSubmit={send} className="flex gap-2 mt-4">
            <Input data-testid="chat-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Escreva uma mensagem ou sugestão…" />
            <Button type="submit" data-testid="chat-send" className="bg-blue-600 hover:bg-blue-700 hover:text-white text-white gap-1.5"><PaperPlaneTilt size={16} weight="fill" /> Enviar</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
